import React from 'react'
import { Card } from 'antd'
import { Column } from '@ant-design/charts'
import { formatNb } from '../utils/utils'

const ChartColumn = ({ data, title }) => {
    var config = {
        data: data,
        xField: '_id',
        yField: 'amount',
        label: {
            position: 'middle',
            style: {
                fill: '#FFFFFF',
                opacity: 0.6,
            },
            formatter: (datum) => formatNb(datum.amount),
        },
        tooltip: {
            formatter: (datum) => ({
                name: datum._id,
                value: '¥ ' + formatNb(datum.amount),
            }),
        },
        meta: {
            type: { alias: 'category' },
            sales: { alias: 'sales' },
        },
    }
    return (
        <Card title={title} className="chart-card" style={{ width: 638 }}>
            <Column style={{ height: 250 }} {...config} />
        </Card>
    )
}

export default ChartColumn
